import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/rooms")({
  component: RouteComponent,
  beforeLoad: () => {
    return { title: "Rooms" };
  },
});

function RouteComponent() {
  return (
    <>
      <Outlet />
    </>
  );
}
